// extracted by mini-css-extract-plugin
export default {"container":"Category_container__Uq1z2","card":"Category_card__P9x+Y","cardImg":"Category_cardImg__9hsk9"};